<template>
  <a-form-item :label="options.label" has-feedback>
    <a-select
      :mode="mode"
      show-search
      :default-active-first-option="true"
      :label-in-value="!editMode"
      :placeholder="options.placeholder"
      :style="{ width: options.width}"
      :filter-option="false"
      :show-arrow="false"
      :allowClear="options.allow_clear"
      :not-found-content="loading ? undefined : null"
      :disabled="disabled"
      :loading="loading"
      @search="searchContact"
      @change="handleChangeValue"
      @deselect="deleteOption"
      @select="selectSearchValue"
      @clear="clearSelect"
      v-decorator="[options.field,{ initialValue: mode === null ? null :undefined,rules: [{ required: required, message: `Please enter field ${options.label}!` }] }]"
    >
      <span slot="dropdownRender" slot-scope="menu">
        <v-nodes :vnodes="menu" />
        <template v-if="options.is_add_extra_footer">
          <a-divider style="margin: 2px 0;" />
          <a-button
            type="link"
            style=" cursor: pointer;"
            @mousedown="e => e.preventDefault()"
            @click="CreateNewClient"
          >
            <span v-if="options.extra_footer_time_cat">extra_footer_time_cat</span>
            <span v-else><a-icon type="plus" /> Create New Client</span>
          </a-button>
        </template>
      </span>

      <a-icon slot="suffixIcon" type="search" />
      <a-spin v-if="loading" :indicator="indicator" slot="notFoundContent" size="small" />

      <template v-if="is_include_matter">
        <a-select-option v-for="(matter,index) in matters" :key="matter.id" :value="matter.id">
          {{ matter.title }}
        </a-select-option>
      </template>
      <template v-else-if="is_include_bank_account">
        <a-select-option v-for="(account,index) in accounts" :key="account.id" :value="account.id">
          {{ account.account_name }} {{ (account.amount) }}
        </a-select-option>
      </template>
      <template v-else>
        <a-select-option v-for="(item,index) in rows" :key="item.id" :value="item.id">
          <template v-if="item.person || item.company">
            <template v-if="item.person">
              {{ item.person.first_name }} {{ item.person.last_name }}
            </template>
            <template v-else>
              {{ item.company.name }}
            </template>
          </template>
        </a-select-option>
      </template>

    </a-select>

  </a-form-item>
</template>

<script>
import Mixin from "@/views/mixin/mixin";
import axios from "@/axios";
import debounce from 'lodash/debounce';

export default {
  name: "selectSearch",
  mixins: [Mixin],
  components:{
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  props:{
    disabled:{
      type    : Boolean,
      default : false
    },
    is_include_matter:{
      type: Boolean,
      default: false
    },
    is_include_bank_account:{
      type: Boolean,
      default: false
    },
    filterResponsibleOrigination: {
      type: Boolean,
      default: true
    },
    options:{
      type:Object,
      required: true,
      default:{
        placeholder:'search',
        label:'Client',
        field:'client',
        width: '100%',
        allow_clear: true,
        is_add_extra_footer: false,
        extra_footer_time_cat: false, // TODO: This is an ad hoc, quick fix, dirty hack. Implement the footer of this component properly.
      }
    },
    url:{
      type:String,
      default: '/contact/query/'
    },
    required:{
      type: Boolean,
      default: false
    },
    mode:{
      type:String,
      default: null
    }
  },
  data(){
    this.searchContact = debounce(this.searchContact, 500);
    return{
      loading: false,
      rows: [],
      matters:[],
      accounts: [],
      query: [],
      indicator: <a-icon type="loading" style="font-size: 16px" spin />,
    }
  },
  methods:{

    CreateNewClient(){
      this.$emit('click')
    },

    deleteOption(key){
      this.$emit('deleteOption',key)
    },

    selectSearchValue(value){
      this.$emit('selectSearchValue',value)
    },
    async searchContact(value) {
      try {
        this.loading = true;
        if(value){
          this.rows = []
          this.matters = []
          this.accounts = []
        }
        const {data} = await axios.post(this.url,{ search : value, limit: 100, query: this.query })
        this.url === '/contact/query/' ? this.rows = data.rows : this.url === '/matter/query/' ?  this.matters = data.rows : this.accounts = data.rows
      }catch (e) {
        throw e
      }finally {
        this.loading = false
      }
        // let map   = new Map(res.data.rows.map(item => [item.id,item]));
       //this.rows = [...map.values()];
    },
    handleChangeValue(value) {
          this.$emit('selectSearch',value,this.is_include_matter)
          const find = this.rows.find(item=>item.id === value)
          if(this.is_include_matter){
              const find_matter = this.matters.find(item=>item.id === value)
               if (find){
                  Object.assign(this, {
                    value: find.person ? `${find.person.first_name}${find.person.last_name}` : find.company && find.company.name ? find.company.name : find_matter.title,
                    data: [],
                    loading: false
                  })
               }
          }else if(this.is_include_bank_account){
            const find_account = this.accounts.find(item=>item.id === value)
            if (find_account){
              Object.assign(this, {
                value: value,
                data: [],
                loading: false
              })
            }
          } else {
              if(find) {
                Object.assign(this, {
                  value: find.person ? `${find.person.first_name}${find.person.last_name}` : find.company.name,
                  data: [],
                  loading: false
                });
              }
              this.$emit('finalQuery',value)
          }
    },
    clearSelect() {
      console.log('clear')
    }
  },
  async mounted() {
    await this.searchContact()
  }
}
</script>

<style>
[dir] .ant-select-selection {
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-top-width: 1.02px;
  border-radius: 3px;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
</style>
